import React, { useEffect, useState } from 'react'
// import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import "./index.css";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import axios from 'axios';
import { FaCheck } from "react-icons/fa6";

export default function LinkUploadTestModel(props) {
  const { model, uid, handleAlert } = props;

  const navigate = useNavigate();
  // const [cookies, setCookie] = useCookies([""]);

  const [uploaded, setUploaded] = useState(false);
  const [url, setUrl] = useState('')
  const currYear = new Date().getFullYear()
  const [year, setYear] = useState(currYear + 1)
  const [yearSelectList, setYearSelectList] = useState([]);

  useEffect(() => {
    const tmp = [];
    for (let i = currYear + 1; i < currYear + 11; i++) {
      tmp.push(i);
    }
    setYearSelectList(tmp);
  }, [currYear])

  const getUrl = e => {
    setUrl(e.currentTarget.value)
  }

  const handleSubmit = () => {
    if (model.id === 4) {
      // check if the url is from cars.com
      const urlpre = 'https://www.cars.com/vehicledetail/'
      if (url.startsWith(urlpre, 0)) {
        axios({
          method: "post",
          url: '/api/m2d/models/vpptest',
          data: {
            link: url,
            year: year,
            uid: uid
          }
        }).then(res => {
          setUploaded(true);
          handleAlert('success', 'Successfully submitted!');
        }).catch(err => {
          handleAlert('error', err.message, 3000);
          console.log(err)
        })
      } else {
        handleAlert('error', 'Wrong URL!', 3000);
      }
    }

  }


  const handleClear = () => {
    setUrl('')
  }

  const handleYear = e => {
    setYear(e.target.value)
  }

  const handleConfirm = () => {
    if (uploaded === true) {
      setUploaded(false);
    }
  };

  const handleResult = () => {
    if (uploaded === true) {
      navigate("/m2d/history");
    }
  };

  return (
    <div className='test-model-content'>
      <div className={`success${uploaded ? "" : "-close"}`}>
        <FaCheck
          style={{
            fontSize: "60px",
            color: "rgb(0, 171, 0)",
            marginTop: "10px",
          }}
        />
        <div className="success-info">Successfully submitted!</div>
        <div className="success-sub-info">
          It may take a while before we're able to show you the results. You
          can track the progress in your account page.
        </div>
        <div className="confirm-btn-area">
          <div className="confirm-btn" onClick={handleConfirm}>
            Confirm
          </div>
          <div className="result-btn" onClick={handleResult}>
            Go to account
          </div>
        </div>
      </div>
      <div className={`data-info${uploaded ? "-close" : ""}`}>
        {model.dataDescription}
      </div>
      <div className={`input-box${uploaded ? "-close" : ""}`}>
        <TextField label="link" variant="outlined" onChange={getUrl} sx={{ width: '500px' }} />
        {model.id === 4 ? (
          <FormControl sx={{ marginLeft: '10px', width: '120px' }}>
            <InputLabel id="select-year">Year</InputLabel>
            <Select
              labelId="select-year"
              id="select-year-select"
              value={year}
              label="Year"
              onChange={handleYear}
            >
              {
                yearSelectList.map((y) => (
                  <MenuItem value={y} key={y}>{y}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
        ) : null}
      </div>
      <div className={`link-upload-btns${uploaded ? "-close" : ""}`}>
        <Button variant='contained' onClick={handleSubmit} sx={{ marginRight: '10px', width: '100px' }}>Submit</Button>
        <Button variant='outlined' color="error" onClick={handleClear} sx={{ width: '100px' }}>Clear</Button>
      </div>
    </div>
  )
}
